import { render, staticRenderFns } from "./OtherPeriodsFields.vue?vue&type=template&id=722de95c&scoped=true"
import script from "./OtherPeriodsFields.vue?vue&type=script&lang=js"
export * from "./OtherPeriodsFields.vue?vue&type=script&lang=js"
import style0 from "./OtherPeriodsFields.vue?vue&type=style&index=0&id=722de95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722de95c",
  null
  
)

export default component.exports